module.exports = __webpack_public_path__ + "img/16581300_L.16511580.png";